import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { MARCASPRODUCTO,IMarcasProductPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
///* tanSctack query
export const useFetchMarcasProduct = ({
    page = 1,
    page_size = 10,
    nombre = '',
  }: GetMarcasProductParams) => {
    return useQuery({
      queryKey: ['marca-producto', page, nombre, page_size],
      queryFn: async () => {
        return getMarcaProductos({ page, nombre, page_size });
      },
    });
  };
  
  export const useGetMarcaProducto = (id: string) => {
    return useQuery({
      queryKey: ['marca-producto', id],
      queryFn: async () => {
        return getMarcaProduct(id);
      },
    });
  };
  
  export const useCreateMarcasProduct = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createMarcaProduct,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['marca-producto'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Marca de producto creada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  export const useUpdateMarcaProduct = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateMarcaProduct,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['marca-producto'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Marca de producto actualizada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  ///* axios
  export type GetMarcasProductParams = Partial<MARCASPRODUCTO> & {
    page?: number;
    page_size?: number;
    nombre?: string;
  };
  
  export type CreateMarcasProductParams = Omit<MARCASPRODUCTO, 'id_marca_producto'>;
  export type UpdateMarcaProductParams = {
    id: string;
    data: CreateMarcasProductParams;
  };
  
  export const getMarcaProductos = async (params?: GetMarcasProductParams) => {
    const queryParams = getUrlParamsFetch({ ...params });  
    return get<IMarcasProductPagingRes>(
      `${urlBackend}api/v1/marca/?${queryParams}`,
      true
    );
  };
  
  export const getMarcaProduct = async (id: string) => {
    try{
      return await get<MARCASPRODUCTO>(`${urlBackend}api/v1/marca/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
  };
  
  export const createMarcaProduct = async (data: CreateMarcasProductParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
  
    return post<MARCASPRODUCTO>(`${urlBackend}api/v1/marca/`, data, true);
  };
  
    
  export const updateMarcaProduct = async ({ id, data }: UpdateMarcaProductParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);

    return put<MARCASPRODUCTO>(`${urlBackend}api/v1/marca/${id}/`, data, true);
  };
  
  